import { FunctionComponent, useContext } from "react";
import styles from "./stickyMenu.module.scss";
import HamburgerMenu from "./HamburgerMenu/HamburgerMenu";
import NavBar from "./NavBar";
import { MenuContext } from "providers/MenuProvider";
import { ReferenceContext } from "providers/ReferenceProvider";

const StickyMenu: FunctionComponent = () => {
  const { currentPageY } = useContext(ReferenceContext);

  // getting the current window height. Do not display sticky if the view is still on the first page of the site
  const isHomePage = currentPageY <= window.innerHeight - 200;
  if (isHomePage) {
    return null;
  }

  return (
    <MenuContext.Consumer>
      {(menuState) => (
        <div id={"stickyMenu"} className={styles.stickyMenu} tabIndex={1}>
          <HamburgerMenu
            className={styles.stickyHamburgerMenu}
            isHamburgerMenuOpen={menuState.isHamburgerMenuOpen}
            setIsHamburgerMenuOpen={menuState.setIsHamburgerMenuOpen}
          />
          <NavBar className={styles.stickyNavBar} />
        </div>
      )}
    </MenuContext.Consumer>
  );
};

export default StickyMenu;
